const scrollDirection = {
    TOP: 'TOP',
    BOTTOM: 'BOTTOM',
};

export default scrollDirection;
